import { Reveal, Eyebrow } from "./Reveal";
import { SectionMedia, useMediaItems } from "./SectionMedia";
import { useApp } from "../store";

export const GallerySection = () => {
  const { c, t } = useApp();
  const items = useMediaItems().filter((m) => (m.section || "realisations") === "realisations");

  if (items.length === 0) return null;

  return (
    <section id="realisations" data-testid="gallery-section" className="relative text-white grain" style={{ background: "var(--sec-realisations-bg, #101E3D)" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32 relative z-10">
        <Reveal className="max-w-2xl mb-14">
          <Eyebrow>{t("gallery_eyebrow")}</Eyebrow>
          <h2 data-testid="gallery-title" className="mt-5 font-display font-semibold text-2xl sm:text-3xl lg:text-4xl tracking-tight">
            {c("gallery_title")}
          </h2>
          <p data-testid="gallery-sub" className="mt-4 text-sm sm:text-base text-white/60 leading-relaxed">
            {c("gallery_sub")}
          </p>
        </Reveal>

        <SectionMedia section="realisations" light />
      </div>
    </section>
  );
};
